import request from '../common/request.js';

//获取设备列表
export function GetDeviceList(payload) {
    return request.post('/device/GetDeviceList', payload);
}

//添加设备
export function AddDevice(payload) {
    return request.post('/device/AddDevice', payload);
}

//更新设备
export function UpdateDevice(payload) {
    return request.post('/device/UpdateDevice', payload);
}

//删除设备
export function DeleteDevice(payload) {
    return request.post('/device/DeleteDevice', payload);
}



//获取设备配置项列表
export function GetDeviceSettingList(payload) {
    return request.post('/device/GetDeviceSettingList', payload);
}


//添加设备配置项列表
export function AddDeviceSetting(payload) {
    return request.post('/device/AddDeviceSetting', payload);
}

//删除设备配置项列表
export function DeleteDeviceSetting(payload) {
    return request.post('/device/DeleteDeviceSetting', payload);
}




//获取设备已授权应用列表
export function GetDeviceAppList(payload) {
    return request.post('/device/GetDeviceAppList', payload);
}

//添加设备授权应用
export function AddDeviceApp(payload) {
    return request.post('/device/AddDeviceApp', payload);
}

//更新设备授权应用
export function UpdateDeviceApp(payload) {
    return request.post('/device/UpdateDeviceApp', payload);
}

//删除设备授权应用
export function DeleteDeviceApp(payload) {
    return request.post('/device/DeleteDeviceApp', payload);
}

//获取权限组列表
export function GetRightGroupList(payload) {
    return request.post('/device/GetRightGroupList', payload);
}

//初始化数据库表
export function InitAppDataTable(payload) {
    return request.post('/device/InitAppDataTable', payload);
}

//获取设备应用类型
export function GetDACategorylist(payload) {
    return request.post('/DeviceAppCategory/GetDACategorylist', payload);
}

//添加设备应用类型分类
export function AddDACategorylist(payload) {
    return request.post('/DeviceAppCategory/AddDACategorylist', payload);
}

//更新设备应用类型分类
export function UpdateDACategorylist(payload) {
    return request.post('/DeviceAppCategory/UpdateDACategorylist', payload);
}

//删除设备应用类型分类
export function DeleteDACategorylist(payload) {
    return request.post('/DeviceAppCategory/DeleteDACategorylist', payload);
}
